import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handle = (value: string) => {
    localStorage.setItem("cookie-consent", value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="fixed bottom-20 sm:bottom-6 right-3 left-3 sm:left-auto z-[60] w-auto sm:max-w-sm md:max-w-lg rounded-2xl border border-border bg-card p-4 sm:p-6 shadow-2xl sm:right-6"
        >
          <h3 className="text-base sm:text-lg font-semibold text-foreground mb-1.5 sm:mb-2">Cookie Settings</h3>
          <p className="text-xs sm:text-sm text-muted-foreground mb-4 sm:mb-5">
            We use cookies to enhance your experience, analyse site traffic and deliver personalised content. Read our{" "}
            <a href="/security" className="text-foreground underline underline-offset-2 hover:text-primary">
              Privacy Policy
            </a>
            .
          </p>
          <div className="flex gap-2 sm:gap-3">
            <button
              onClick={() => handle("rejected")}
              className="flex-1 rounded-full border border-border bg-background px-4 sm:px-6 py-2 sm:py-2.5 text-xs sm:text-sm font-medium text-foreground transition-colours hover:bg-muted"
            >
              Reject
            </button>
            <button
              onClick={() => handle("accepted")}
              className="flex-1 rounded-full bg-foreground px-4 sm:px-6 py-2 sm:py-2.5 text-xs sm:text-sm font-medium text-background transition-colours hover:bg-foreground/90"
            >
              Accept
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
